RivalIQ.apps.LandscapeSettings.module('views', function (views) {

    'use strict';

    views.EmailListModal = RivalIQ.apps.LandscapeSettings.views.EmailList.extend({
        ui: {
            input: 'input',
            table: 'table',
            modal: '.modal',
            email: 'input[name="email"]',
            helpText: '.help-block'
        },
        collectionEvents: {
            add: 'showOrHideTable',
            remove: 'showOrHideTable'
        },
        template: '#notificationEmailListModalTemplate',
        childView: RivalIQ.apps.LandscapeSettings.views.AccountEmail,
        onRender: function () {
            const me = this;
            me.showOrHideTable();

            me.ui.modal.on('shown.bs.modal', function () {

                me.ui.email.focus();
            });

            me.ui.modal.modal();
        },
        getStateManager: function () {
            // account settings
            return RivalIQ.state.account;
        },
        showOrHideTable: function () {
            const me = this;
            const table = me.ui.table;

            if (me.collection.length > 0) {
                table.removeClass('hide');
            } else {
                table.addClass('hide');
            }
        }
    });
});
